module.exports = __webpack_public_path__ + "img/login_title.4a381fcb.png";